export enum BatchingMethod {
	ByRecord,
	ByField,
}
